import { useMemo } from 'react';
export function useIndexedData(dataToUse, rowIndexer) {
  return useMemo(() => {
    let i = 0;
    return dataToUse.filter(group => group.data.length > 0).map((group, index) => ({
      ...group,
      data: group.data.map(data => ({
        ...data,
        _id: rowIndexer(data, i++)
      })),
      _id: index
    }));
  }, [dataToUse, rowIndexer]);
}